import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

export type ColorTheme = 'light' | 'dark';

const STORAGE_KEY = 'autooptiq-color-theme';
const DARK_CLASS = 'dark-mode';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private renderer: Renderer2;
  private theme: ColorTheme = 'light';

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.theme = this.readStoredTheme();
    this.apply(this.theme);
  }

  get isDarkMode(): boolean {
    return this.theme === 'dark';
  }

  get currentTheme(): ColorTheme {
    return this.theme;
  }

  setDarkMode(enabled: boolean): void {
    this.setTheme(enabled ? 'dark' : 'light');
  }

  toggle(): void {
    this.setTheme(this.theme === 'dark' ? 'light' : 'dark');
  }

  private setTheme(theme: ColorTheme): void {
    this.theme = theme;
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (err) {}
    this.apply(theme);
  }

  private apply(theme: ColorTheme): void {
    const isDark = theme === 'dark';
    if (isDark) {
      this.renderer.addClass(document.body, DARK_CLASS);
    } else {
      this.renderer.removeClass(document.body, DARK_CLASS);
    }
    this.renderer.setAttribute(document.documentElement, 'data-theme', theme);
  }

  private readStoredTheme(): ColorTheme {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
    } catch (err) {
      return 'light';
    }
  }
}
